var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalLineAppbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 50,
    viewBox: "0 0 1 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18561e-8,
    x2: 0.499998,
    y2: 50,
    stroke: "#CBC8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLineAppbar);
export default __webpack_public_path__ + "static/media/verticalLineAppbar.f2e24d71f1e5bdfc3fb0a3a65e553446.svg";
export { ForwardRef as ReactComponent };